import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { ReportingComponent } from '../../../../components/src/lib/reporting/reporting.component';
import { routeGuardFn } from '../../../../components/src/lib/shared/services/route-guard.service';
import { ziroFormConfirmRouteChangeGuardFn } from '../../../../components/src/lib/forms/ziro-form-confirm-route-change.service';
import { MicrosoftDialPlanInventoryReportComponent } from '../../../../components/src/lib/reporting/microsoft/dial-plan-inventory-report/dial-plan-inventory-report.component';
import { CallLogsComponent } from '../../../../components/src/lib/reporting/cisco/call-logs/call-logs.component';
import { DashboardComponent } from '../../../../components/src/lib/reporting/cisco/dashboard/dashboard.component';
import { OrphanedDevicesComponent } from '../../../../components/src/lib/reporting/cisco/orphaned-devices/orphaned-devices.component';
import { DnAvailabilityComponent } from '../../../../components/src/lib/reporting/cisco/dn-availability/dn-availability.component';
import { DeviceUtilizationComponent } from '../../../../components/src/lib/reporting/cisco/device-utilization/device-utilization.component';
import { LineAppearanceManagementReportComponent } from '../../../../components/src/lib/reporting/cisco/bulk-line-appearance-management/line-appearance-management-report.component';
import { CucmLicenseOptimizationComponent } from '../../../../components/src/lib/reporting/cisco/cucm-license-optimization/cucm-license-optimization.component';
import { CucmLicenseOptimizationOverviewComponent } from '../../../../components/src/lib/reporting/cisco/cucm-license-optimization/cucm-license-optimization-overview/cucm-license-optimization-overview.component';
import { CucmLicenseOptimizationCandidatesComponent } from '../../../../components/src/lib/reporting/cisco/cucm-license-optimization/cucm-license-optimization-candidates/cucm-license-optimization-candidates.component';
import { GlobalDirectoryComponent } from '../../../../components/src/lib/reporting/cisco/global-directory/global-directory.component';
import { UnusedPhoneButtonTemplatesComponent } from '../../../../components/src/lib/reporting/cisco/unused-phone-button-templates/unused-phone-button-templates.component';
import { CustomReportsComponent } from '../../../../components/src/lib/reporting/cisco/custom-reports/custom-reports.component';
import { CustomReportsListComponent } from '../../../../components/src/lib/reporting/cisco/custom-reports/custom-reports-list/custom-reports-list.component';
import { CucmReportBuilderComponent } from '../../../../components/src/lib/reporting/cisco/custom-reports/cucm-report-builder/cucm-report-builder.component';
import { AuditLogsComponent } from '../../../../components/src/lib/admin/audit/audit-logs/audit-logs.component';
import { PstnCallingUsageReportComponent } from '../../../../components/src/lib/reporting/microsoft/pstn-calling-usage-report/pstn-calling-usage-report.component';
import { PolicyMisconfigurationReportComponent } from '../../../../components/src/lib/reporting/microsoft/policy-misconfiguration-report/policy-misconfiguration-report.component';
import { PstnCallRecordFinderComponent } from '../../../../components/src/lib/reporting/microsoft/pstn-call-record-finder/pstn-call-record-finder.component';
import { CustomPowershellQueriesComponent } from '../../../../components/src/lib/reporting/microsoft/custom-powershell-queries/custom-powershell-queries.component';
import { CustomPowershellQueriesEditComponent } from '../../../../components/src/lib/reporting/microsoft/custom-powershell-queries/custom-powershell-queries-edit.component';
import { MisconfiguredVoiceAppsComponent } from '../../../../components/src/lib/reporting/microsoft/misconfigured-voice-apps/misconfigured-voice-apps.component';

export const reportingRouteChildrenConfig: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  {
    path: 'tenants/:tenantId',
    children: [
      { path: '', redirectTo: 'audit-logs', pathMatch: 'full' },
      {
        path: 'audit-logs',
        component: AuditLogsComponent,
        canActivate: [routeGuardFn],
        canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
        data: {
          title: 'tkey;reports.microsoft.audits.logs.title',
        },
      },
      {
        path: 'dial-plan-inventory',
        component: MicrosoftDialPlanInventoryReportComponent,
        canActivate: [routeGuardFn],
        data: {
          title: 'tkey;reports.microsoft.dial_plan_inventory.title',
        },
      },
      {
        path: 'custom-powershell-reports',
        redirectTo: 'custom-powershell-queries',
      },
      {
        path: 'custom-powershell-queries',
        canActivate: [routeGuardFn],
        children: [
          {
            path: '',
            component: CustomPowershellQueriesComponent,
            data: {
              title: 'tkey;reports.microsoft.custom_powershell_reports.title',
            },
          },
          {
            path: 'new-report',
            component: CustomPowershellQueriesEditComponent,
            data: {
              title: 'tkey;reports.microsoft.custom_powershell_reports.title',
            },
          },
          {
            path: ':id',
            component: CustomPowershellQueriesEditComponent,
            data: {
              title: 'tkey;reports.microsoft.custom_powershell_reports.title',
            },
          },
        ],
      },
      {
        path: 'teams-pstn-calling-usage',
        component: PstnCallingUsageReportComponent,
        canActivate: [routeGuardFn],
        data: {
          title: 'tkey;reports.microsoft.teams_pstn_calling_usage.title',
        },
      },
      {
        path: 'policy-misconfiguration-report',
        redirectTo: 'policy-misconfigurations',
      },
      {
        path: 'policy-misconfigurations',
        component: PolicyMisconfigurationReportComponent,
        canActivate: [routeGuardFn],
        data: {
          title: 'tkey;reports.microsoft.policy_misconfig.title',
        },
      },
      {
        path: 'misconfigured-voice-apps',
        component: MisconfiguredVoiceAppsComponent,
        canActivate: [routeGuardFn],
        data: {
          title: 'tkey;reports.microsoft.misconfigured_voice_apps.title',
        },
      },
      {
        path: 'pstn-call-record-finder',
        component: PstnCallRecordFinderComponent,
        canActivate: [routeGuardFn],
        data: {
          title: 'tkey;reports.microsoft.pstn_call_record_finder.title',
        },
      },
    ],
  },
  {
    path: 'call-logs',
    component: CallLogsComponent,
    canActivate: [routeGuardFn],
    data: {
      title: 'tkey;reports.call_logs.title',
    },
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [routeGuardFn],
    data: {
      title: 'tkey;menu.report.dashboard',
    },
  },
  {
    path: 'orphaned-devices',
    component: OrphanedDevicesComponent,
    canActivate: [routeGuardFn],
    canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
    data: {
      title: 'tkey;menu.admin.admin.orphaned_devices',
    },
  },
  {
    path: 'dn-availability',
    component: DnAvailabilityComponent,
    canActivate: [routeGuardFn],
    data: {
      title: 'tkey;reports.dn_availability.title',
    },
  },
  {
    path: 'device-utilization',
    component: DeviceUtilizationComponent,
    canActivate: [routeGuardFn],
    canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
    data: {
      title: 'tkey;reports.device_utilization.title',
    },
  },
  {
    path: 'bulk-line-appearance-management',
    component: LineAppearanceManagementReportComponent,
    canActivate: [routeGuardFn],
    canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
    data: {
      title: 'tkey;reports.bulk_line_appearance_management.title',
    },
  },
  {
    path: 'cucm-license-optimization',
    component: CucmLicenseOptimizationComponent,
    canActivate: [routeGuardFn],
    children: [
      {
        path: '',
        component: CucmLicenseOptimizationOverviewComponent,
        data: {
          title: 'tkey;reports.cucm_license_optimizer.overview.title',
        },
      },
      {
        path: ':licenseTier',
        component: CucmLicenseOptimizationCandidatesComponent,
        canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
        data: {
          title: 'tkey;reports.cucm_license_optimizer.candidates.title',
        },
      },
    ],
  },
  {
    path: 'global-directory',
    component: GlobalDirectoryComponent,
    canActivate: [routeGuardFn],
    canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
    data: {
      title: 'tkey;reports.global_directory.title',
    },
  },
  {
    path: 'unused-phone-button-templates',
    component: UnusedPhoneButtonTemplatesComponent,
    canActivate: [routeGuardFn],
    canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
    data: {
      title: 'tkey;menu.report.unused_phone_button_template.title',
    },
  },
  {
    path: 'custom-reports',
    component: CustomReportsComponent,
    children: [
      {
        path: '',
        component: CustomReportsListComponent,
        canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
        data: {
          title: 'tkey;reports.custom_reports.title',
        },
      },
      {
        path: 'new-report',
        component: CucmReportBuilderComponent,
        canActivate: [routeGuardFn],
        canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
        data: {
          title: 'tkey;reports.custom_reports.new_report.title',
        },
      },
      {
        path: ':reportId',
        component: CucmReportBuilderComponent,
        canActivate: [routeGuardFn],
        canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
        data: {
          title: 'tkey;reports.custom_reports.edit_report.title',
        },
      },
    ],
  },
];

export const reportingRouteConfig: Routes = [
  {
    path: '',
    component: ReportingComponent,
    canActivate: [routeGuardFn],
    children: reportingRouteChildrenConfig,
  },
];

@NgModule({
  imports: [RouterModule.forChild(reportingRouteConfig)],
  exports: [RouterModule],
})
export class ReportingRoutingModule {}
